(function () {
    'use strict';

    function WZCompanyInfoController(__config, $scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, CompanyCustom) {

        var $ctrl = this;
        $ctrl.checkCompanyKeyUrlIsValid = checkCompanyKeyUrlIsValid;
        $ctrl.isUrlValid = null;
        $ctrl.searchText = '';
        $ctrl.querySearch = querySearch;
        $ctrl.activityTypes = [];
        $ctrl.isDisabled = false;
        $ctrl.__config = __config;

        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {


            translatePartialLoader.addPart('activityType');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();
            //

            loadAllActivityTypes();

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        function loadAllActivityTypes() {
            $ctrl.activityTypes = CompanyCustom.getCompanyActivityTypes();
        }

        function checkCompanyKeyUrlIsValid(onValidate) {
            if ($ctrl.company == null || $ctrl.company == undefined)
                return;

            if ($ctrl.company.keyUrl != undefined && $ctrl.company.keyUrl != null && $ctrl.company.keyUrl.length > 2) {
                $ctrl.company.keyUrl = $ctrl.company.keyUrl.toLowerCase();
                CompanyCustom.findCompanyByKeyURL($ctrl.company.keyUrl.trim()).query().$promise.then(onValidate);
            }
        }

        function querySearch(query) {

            var temp = [];

            angular.forEach($ctrl.activityTypes, function (item) {
                if (item.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.activityTypes;
                }
            })

            return temp;

        }


        $scope.$watch('companyinfoform.$valid', function (isValid) {

            $ctrl.formisValid = isValid;
            if (isValid && $ctrl.isUrlValid) {
                $ctrl.isFormValid(isValid);
            } else {
                $ctrl.isFormValid(false);
            }

        })

        $scope.$watch('$ctrl.company.keyUrl', function () {

            checkCompanyKeyUrlIsValid(function (result) {
                if (result != null && result.id != null) {
                    $ctrl.isUrlValid = false;
                } else {
                    $ctrl.isUrlValid = true;
                }

                if ($ctrl.isUrlValid && $ctrl.formisValid) {
                    $ctrl.isFormValid(true);
                } else {
                    $ctrl.isFormValid(false);
                }
            });

        });


    }

    var WZCompanyInfo = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms/company-info/wizard-form.company-info.html',
        controller: WZCompanyInfoController,
        bindings:
            {
                company: '=?',
                isFormValid: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfCompanyInfo', WZCompanyInfo)

    WZCompanyInfoController.$inject = ['__config', '$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'CompanyCustom'];


})();

